"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowValidator = void 0;
var _BaseValidator = require("../BaseValidator/BaseValidator");
var ShowValidator = exports.ShowValidator = {
  title: _BaseValidator.title,
  description: _BaseValidator.description
};